import { useEffect } from 'react';
import Hero from '@/pages/home/components/Hero';
import Features from '@/pages/home/components/Features';
import CategoryShowcase from '@/pages/home/components/CategoryShowcase';
import DownloadSection from '@/pages/home/components/DownloadSection';
import CreatorSection from '@/pages/home/components/CreatorSection';
import FAQ from '@/pages/home/components/FAQ';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '快猫官网 - 官方正版短视频平台入口',
  description: '快猫官网是快猫短视频的官方正版网站入口，提供最新版本下载、账号注册登录、会员服务及内容创作者入驻通道。',
  url: 'https://www.kuaimao.com',
};

export default function Home() {
  useEffect(() => {
    document.title = '快猫官网 - 官方正版短视频平台入口';
  }, []);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <Features />
          <CategoryShowcase />
          <DownloadSection />
          <CreatorSection />
          <FAQ />
        </main>
        <Footer />
      </div>
    </>
  );
}